import LegalLayout from "@/components/LegalLayout";

const TermsPage = () => (
  <LegalLayout eyebrow="Legal" title="Terms & Conditions" updated="May 2026">
    <p>
      By booking a transfer or tour with Allen Travels RD, you agree to the following terms.
    </p>

    <h2>1. Bookings</h2>
    <p>
      All bookings are subject to availability and confirmation. Prices are quoted in US dollars and include applicable taxes unless stated otherwise.
    </p>

    <h2>2. Payment</h2>
    <p>
      We accept credit card, PayPal, and cash to the driver depending on the service selected at checkout. Online payments are processed by certified gateways.
    </p>

    <h2>3. Cancellations & changes</h2>
    <ul>
      <li>Free cancellation up to 24 hours before the scheduled pickup.</li>
      <li>Cancellations within 24 hours may be charged up to 100% of the booking value.</li>
      <li>Schedule changes are subject to availability — contact us as early as possible.</li>
    </ul>

    <h2>4. Delays & no-shows</h2>
    <p>
      We track all flights in real time. If you are delayed for any reason, we adjust your pickup at no extra cost. No-shows without notice are non-refundable.
    </p>

    <h2>5. Tours</h2>
    <p>
      Tour itineraries may change due to weather, sea conditions, or operator decisions. Safety always comes first.
    </p>

    <h2>6. Liability</h2>
    <p>
      Allen Travels RD is not liable for personal belongings lost during a transfer or tour. Travelers participate in activities at their own risk and should hold their own travel insurance.
    </p>

    <h2>7. Governing law</h2>
    <p>
      These terms are governed by the laws of the Dominican Republic.
    </p>

    <h2>8. Contact</h2>
    <p>
      For questions about these terms, write to <a href="mailto:hello@allentravelsrd.com">hello@allentravelsrd.com</a>.
    </p>
  </LegalLayout>
);

export default TermsPage;
